import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { useFact } from "@/lib/factoryI18n";

export default function FinishingQueue() {
  const { lang } = useLang();
  const { user } = useAuth();
  const f = useFact(lang);
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState("");
  const load = () => api.get("/factory/finishing").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (row, patch) => {
    try {
      await api.patch(`/factory/finishing/${row.id}`, patch);
      load();
    } catch (e) { setMsg("Error: " + (e?.response?.data?.detail || e.message)); }
  };

  return (
    <div data-testid="finishing-queue">
      <h1 className="text-2xl font-bold mb-4" style={{ color: "var(--brand-navy)", fontFamily: "'Fraunces', serif" }}>{f("finishing")}</h1>
      {msg && <div className="text-xs text-red-700 mb-2">{msg}</div>}
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.id} className="bg-white border border-[#1B3A5C]/10 rounded-lg p-3" data-testid={`fin-row-${r.id}`}>
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div>
                <div className="text-sm font-semibold">Op {r.op} · {r.name}</div>
                <div className="text-xs text-[#7C8E9E]">{r.piece?.code} · {r.piece?.design_code} · {r.piece?.size_text}</div>
              </div>
              <div className="flex gap-2 items-center">
                {r.status === "Pending" && (
                  <button data-testid={`fin-start-${r.id}`} onClick={() => setStatus(r, { status: "In Progress", start_at: new Date().toISOString() })} className="tap-target px-3 py-1.5 rounded-full text-xs font-semibold" style={{ background: "var(--brand-gold)", color: "var(--brand-navy)" }}>{f("start")}</button>
                )}
                {r.status === "In Progress" && (
                  <button data-testid={`fin-finish-${r.id}`} onClick={() => setStatus(r, { status: "Done", end_at: new Date().toISOString(), qc_pass: true })} className="tap-target px-3 py-1.5 rounded-full text-xs font-semibold" style={{ background: "var(--brand-navy)", color: "white" }}>{f("finish")}</button>
                )}
                {(user?.role === "prod_qc_coordinator" || user?.role === "coordinator" || user?.role === "director") && r.status !== "Done" && (
                  <button data-testid={`fin-na-${r.id}`} onClick={() => { const reason = prompt("N/A reason?"); if (reason) setStatus(r, { status: "N/A", na_reason: reason }); }} className="tap-target px-3 py-1.5 rounded-full text-xs border border-[#1B3A5C]/20">{f("n_a")}</button>
                )}
                <span className={`text-xs px-2 py-1 rounded-full ${r.status === "Done" ? "bg-green-100 text-green-800" : r.status === "In Progress" ? "bg-amber-100 text-amber-800" : r.status === "N/A" ? "bg-gray-200 text-gray-700" : "bg-blue-100 text-blue-800"}`}>{r.status}</span>
              </div>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="text-sm text-[#7C8E9E]">No pending rows.</div>}
      </div>
    </div>
  );
}
